import React from "react";
import { Modal } from "react-bootstrap";
import Button from "./SurveyButton";

const SurveyConfirmationModal = ({
  show,
  title,
  message,
  confirmLabel = "Confirm",
  confirmStyle = "primary",
  cancelLabel = "Cancel",
  busy = false,
  onConfirm,
  onCancel,
}) => {
  const confirmIcon = {
    danger: "fa-trash",
    primary: "fa-check",
    success: "fa-check-circle",
    warning: "fa-ban",
  }[confirmStyle] || "fa-check";

  const close = () => {
    if (!busy && onCancel) onCancel();
  };

  return (
    <Modal
      show={Boolean(show)}
      onHide={close}
      backdrop={busy ? "static" : true}
      keyboard={!busy}
      className="survey-confirmation-modal"
      aria-labelledby="survey-confirmation-modal-title"
    >
      <Modal.Header closeButton={!busy}>
        <Modal.Title id="survey-confirmation-modal-title">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body><p>{message}</p></Modal.Body>
      <Modal.Footer>
        <Button icon="fa-times" disabled={busy} onClick={close}>{cancelLabel}</Button>
        <Button icon={busy ? null : confirmIcon} bsStyle={confirmStyle} disabled={busy} onClick={onConfirm}>
          {busy && <i className="fa fa-spinner fa-spin" aria-hidden="true" />}
          {busy ? ` ${confirmLabel}` : confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SurveyConfirmationModal;
